import styled from 'styled-components';

export const ContentWrapper = styled.div(
  props => `
    padding-top: 3rem;
`,
);
export const HeaderWrap = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 1rem;
  font-size: 1.4rem;
  font-weight: bold;
  color: black;
  .headerLeft {
    width: 70%;
  }
  .headerRight {
    width: 30%;
  }
`;
export const Header = styled.h3`
  font-size: 1.4rem;
  font-weight: bold;
  color: black;
  padding: 2rem 0;
`;
export const IconTick = styled.i`
  font-size: 1.2rem;
  color: #18a160;
  padding-right: 1rem;
`;
export const ListItem = styled.p`
  padding-bottom: 1rem;
  padding-left: 1rem;
`;
export const PoliciesWrap = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: row;
  margin-bottom: 2rem;
`;
export const PolicyContent = styled.div`
  padding: 1.5rem 1.5rem 0;
  width: 70%;
  p {
    padding-bottom: 1.8rem;
    font-size: 1.2rem;
    color: #777;
  }
`;
export const PolicyCharge = styled.div`
  padding: 1.5rem 1.5rem 0;
  width: 30%;
  border-left: 1px solid #e1e1e1;

  a {
    font-size: 1.2rem;
  }
`;
export const Percentage = styled.span`
  font-size: 1.4rem;
  color: #1c1c1c;
  display: flex;
  justify-content: space-between;
`;
export const TooltipContentWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.5rem;
`;
export const Tooltip = styled.div`
  position: relative;
  color: #2276e3;
  cursor: pointer;
  &:hover .top {
    display: block;
  }
  .top {
    min-width: 240px;
    color: #444444;
    position: absolute;
    z-index: 9;
    right: 0;
    display: none;
    .arrowUpWrap {
      overflow: hidden;
      height: 19px;
      width: 100%;
      display: flex;
    }
    .arrowUp {
      width: 20px;
      height: 20px;
      box-shadow: 0 0 12px -2px rgba(51, 51, 51, 0.3);
      position: relative;
      left: 190px;
      top: 9px;
      background: white;
      display: flex;
      transform: rotate(45deg);
    }
    .content {
      background-color: white;
      box-shadow: 0 0 12px -2px rgba(51, 51, 51, 0.3);
      border-radius: 0.5rem;
      padding: 1.5rem;
    }
    h3 {
      font-size: 1.4rem;
      font-weight: bold;
      color: #777;
      padding-bottom: 1.5rem;
    }
    p {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      span {
        color: #777;
        font-size: 1.2rem;
        font-weight: medium;
        padding-bottom: 1.5rem;
      }
    }
  }
`;
